<!-- File: IoT-Use-Frontend/src/components/NavbarHome1 -->
<template>
    <div class="header-area">
        <div class="sticky-area">
            <div class="navigation">
                <div class="container">
                    <div class="header-inner-box">
                        <div class="logo">
                            <router-link :to="{ name: 'HomeOne' }" class="navbar-brand">
                                <img src="/assets/images/asdl_iot_logo.svg" alt="Asdl - IoT logo">
                            </router-link>
                        </div>

                        <div class="main-menu">
                            <nav class="navbar navbar-expand-lg">
                                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                    aria-expanded="false" aria-label="Toggle navigation">
                                    <span class="navbar-toggler-icon"></span>
                                    <span class="navbar-toggler-icon"></span>
                                    <span class="navbar-toggler-icon"></span>
                                </button>

                                <div class="collapse navbar-collapse justify-content-center"
                                    id="navbarSupportedContent">
                                    <ul class="navbar-nav m-auto">
                                        <li class="nav-item">
                                            <router-link class="nav-link active"
                                                :to="{ name: 'HomeOne' }">Home</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#">Pages</a>
                                            <ul class="sub-menu">
                                                <li><router-link :to="{ name: 'About' }">About Us</router-link></li>
                                                <li><router-link :to="{ name: 'FAQ' }">FAQ's</router-link></li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#">Project</a>
                                            <ul class="sub-menu">
                                                <li><router-link :to="{ name: 'ProjectsPage' }">Projects</router-link>
                                                </li>
                                                <li><router-link :to="{ name: 'SensorData' }">Sensor Data</router-link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link"
                                                :to="{ name: 'Contact' }">Contact</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>

                        <div class="icon-wrapper">
                            <div class="search-icon search-trigger"><i class="las la-search"></i></div>
                        </div>
                        <div v-if="isLoggedIn">
                            <ul>
                                <li>
                                    <router-link class="main-btn primary" :to="{ name: 'UserInformation' }">My
                                        Account</router-link>
                                </li>
                                <li>
                                    <button class="nav-item" @click="signOut">User Logout</button>
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <div class="header-btn">
                                <router-link class="main-btn primary" :to="{ name: 'auth' }">User Login</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Session from 'supertokens-web-js/recipe/session';

export default {
    async mounted() {
        this.isLoggedIn = await Session.doesSessionExist();
        console.log(this.isLoggedIn ? "logged in navbar" : "no login yet");
    },
    data() {
        return {
            isLoggedIn: false
        }
    },
    methods: {
        async signOut() {
            if (await Session.doesSessionExist()) {
                console.log("Signing out");
                await Session.signOut();
                this.isLoggedIn = false;
                console.log("signed out");
                alert("signed out");
                window.location.href = "/";
            }
        }
    }
};
</script>
<style scoped>
.logo img {
    width: 150px;
    height: auto;
    display: block;
}

.main-menu .navbar-nav .nav-link {
    font-size: 20px;
    font-weight: 500;
    display: block;
    padding: 35px 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #1a2026;
}

.header-area .header-inner-box .logo {
    height: 90px;
    display: flex;
    align-items: center;
    padding-right: 0px;
}

/* --- Additions for Spacing --- */
.header-inner-box {
    display: flex;
    align-items: center;
    width: 100%;
}

.logo {
    margin-right: 30px;
    /* Space AFTER the logo. Adjust value. */
    flex-shrink: 0;
}

.main-menu {
    /* This pushes everything AFTER .main-menu to the right */
    margin-left: 20px;
    /* Optional: space between logo and menu */
    margin-right: auto;
    flex-grow: 1;
    /* Allows menu to take space if needed, but margin:auto is key */
}

.icon-wrapper {
    /* margin-left: auto; /* Use this if you want the menu NOT pushed */
    margin-right: 20px;
    /* Space BETWEEN search and login. Adjust. */
    flex-shrink: 0;
}

/* Target the conditional login/account blocks. */
/* It's better to add a class to these divs in the template */
.user-actions {
    display: flex;
    align-items: center;
    gap: 15px;
    /* Space between My Account and Logout */
    flex-shrink: 0;
}

.header-btn {
    flex-shrink: 0;
}

/* --- Login/Logout button styling --- */
.user-actions ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    /* Space between Account and Logout */
}

.user-actions button.nav-item {
    background: none;
    border: 1px solid var(--color-primary, #007bff);
    /* Use your theme's color */
    color: var(--color-primary, #007bff);
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
}

.user-actions button.nav-item:hover {
    background: var(--color-primary, #007bff);
    color: white;
}
</style>